module.exports = __webpack_public_path__ + "static/Future-of-Work-Template-Articles-1280-x-720-10-800x450-6c01e032dd17e17f5ba53f00c14f4397.png";